module.exports = __webpack_public_path__ + "50c66efec53dff3505190c2bf9dd0048.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/foundation/orbit/right-arrow.png
// module id = 163
// module chunks = 0